export const getClassName = (classes) => classes.join(' ')
